const topics = [
  { id: 1, label: '韩漫推荐', icon: 'ri-heart-line', heat: '128万讨论' },
  { id: 2, label: '日漫新番', icon: 'ri-sun-line', heat: '96万讨论' },
  { id: 3, label: '国漫崛起', icon: 'ri-flag-2-line', heat: '87万讨论' },
  { id: 4, label: '恋爱漫画', icon: 'ri-heart-add-line', heat: '75万讨论' },
  { id: 5, label: '玄幻修仙', icon: 'ri-meteor-line', heat: '69万讨论' },
  { id: 6, label: '校园日常', icon: 'ri-building-line', heat: '58万讨论' },
  { id: 7, label: '悬疑推理', icon: 'ri-search-eye-line', heat: '52万讨论' },
  { id: 8, label: '耽美专区', icon: 'ri-star-line', heat: '44万讨论' },
  { id: 9, label: '百合纯爱', icon: 'ri-flower-line', heat: '38万讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-hashtag text-secondary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">最受关注的漫画话题，找到你的同好圈子</p>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-secondary-300 hover:bg-secondary-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-200 transition-colors">
                <i className={`${topic.icon} text-secondary-500 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{topic.label}</h3>
                <span className="text-xs text-foreground-500">{topic.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}